import React from 'react';
import CardHeader from 'components/CardHeader';
import ExportButton from 'components/Export';
import { I18n } from 'react-redux-i18n';

const PricesEvolutionHeader = ({ exportName }: { exportName: string }) => {
  return (
    <CardHeader
      title={I18n.t('prices.evolution.title')}
      fontSize="20px"
      iconRight
      iconColor="#e25d34"
      rightComponents={
        <ExportButton
          jpg
          pdf
          targetElement="#prices-evolution"
          name={`${exportName} - I18n.t('prices.evolution.title')`}
        />
      }
    />
  );
};

export default PricesEvolutionHeader;
